import React from 'react';
import { useTranslation } from 'react-i18next';

interface MeetingModalProps {
  show: boolean;
  editingMeeting: any | null;
  newMeeting: { description: string; date: string; notes: string };
  onClose: () => void;
  onSave: () => void;
  onDelete: (meetingId: string) => void;
  onChange: (meeting: { description: string; date: string; notes: string }) => void;
  getTodayDate: () => string;
  showConfirm: (message: string, onConfirm: () => void, confirmText?: string) => void;
}

export function MeetingModal({
  show,
  editingMeeting,
  newMeeting,
  onClose,
  onSave,
  onDelete,
  onChange,
  showConfirm
}: MeetingModalProps) {
  const { t, i18n } = useTranslation();

  if (!show) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000
    }}>
      <div style={{
        background: 'white',
        borderRadius: '12px',
        width: '90%',
        maxWidth: '500px',
        maxHeight: '90vh',
        boxShadow: '0 10px 30px rgba(0,0,0,0.3)',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column'
      }}>
        <div style={{ 
          display: 'flex', 
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '20px 30px 15px 30px',
          borderBottom: '1px solid #e9ecef',
          background: 'white',
          borderRadius: '12px 12px 0 0',
          position: 'sticky',
          top: 0,
          zIndex: 10,
          direction: i18n.language === 'he' ? 'rtl' : 'ltr'
        }}>
          <h3 style={{ 
            color: '#000000', 
            margin: 0,
            textAlign: 'center',
            flex: 1
          }}>
            {editingMeeting ? t('patientDetail.editMeeting') : t('patientDetail.addNewMeeting')}
          </h3>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '24px',
              cursor: 'pointer',
              color: '#666',
              width: '30px',
              height: '30px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '50%',
              transition: 'all 0.2s ease'
            }}
            title={t('patientDetail.close')}
          >
            ×
          </button>
        </div>
        
        <div style={{
          padding: '30px',
          overflowY: 'auto',
          flex: 1
        }}>
          <div style={{ marginBottom: '15px' }}>
            <label style={{ color: '#000000', display: 'block', marginBottom: '5px' }}>
              {t('patientDetail.meetingDescription')}
            </label>
            <input
              type="text"
              value={newMeeting.description}
              onChange={(e) => onChange({...newMeeting, description: e.target.value})}
              placeholder={t('patientDetail.enterMeetingDescription')}
              style={{
                width: '100%',
                padding: '10px 12px',
                border: '1px solid #ced4da',
                borderRadius: '6px',
                fontSize: '14px'
              }}
            />
          </div>
          
          <div style={{ marginBottom: '15px' }}>
            <label style={{ color: '#000000', display: 'block', marginBottom: '5px' }}>
              {t('patientDetail.meetingDate')}
            </label>
            <input
              type="date"
              value={newMeeting.date}
              onChange={(e) => onChange({...newMeeting, date: e.target.value})}
              style={{
                width: '100%',
                padding: '10px 12px',
                border: '1px solid #ced4da',
                borderRadius: '6px',
                fontSize: '14px'
              }}
            />
          </div>
          
          <div style={{ marginBottom: '20px' }}>
            <label style={{ color: '#000000', display: 'block', marginBottom: '5px' }}>
              {t('patientDetail.meetingNotes')}
            </label>
            <textarea
              value={newMeeting.notes}
              onChange={(e) => onChange({...newMeeting, notes: e.target.value})}
              placeholder={t('patientDetail.enterMeetingNotes')}
              rows={4}
              style={{
                width: '100%',
                padding: '10px 12px',
                border: '1px solid #ced4da',
                borderRadius: '6px',
                fontSize: '14px',
                resize: 'vertical'
              }}
            />
          </div>
          
          <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
            {editingMeeting && (
              <button
                onClick={() => {
                  showConfirm(
                    t('patientDetail.confirmDeleteMeeting'),
                    () => {
                      onDelete(editingMeeting.id);
                      onClose(); // Close modal after deletion
                    },
                    t('patientDetail.deleteMeeting')
                  );
                }}
                style={{
                  background: '#dc3545',
                  color: 'white',
                  border: 'none',
                  padding: '10px 20px',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  fontSize: '14px'
                }}
              >
                {t('patientDetail.deleteMeeting')}
              </button>
            )}
            <button
              onClick={onSave}
              style={{
                background: '#007acc',
                color: 'white',
                border: 'none',
                padding: '10px 20px',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '14px'
              }}
            >
              {editingMeeting ? t('patientDetail.saveChanges') : t('patientDetail.addMeetingButton')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
